import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const CellPhone: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--cellPhone')}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M20.942 4.25c1.529.002 2.806 1.116 2.808 2.547v19.407c-.002 1.43-1.279 2.544-2.809 2.546h-9.883c-1.529-.002-2.806-1.116-2.808-2.547V6.796c.002-1.43 1.279-2.544 2.809-2.546Zm0 1.5H11.06c-.744 0-1.31.494-1.31 1.047v19.405c0 .554.566 1.047 1.309 1.048h9.881c.744 0 1.31-.494 1.31-1.047V6.798c0-.554-.566-1.047-1.309-1.048ZM16 23a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm2.5-15v1h-5V8h5Z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default CellPhone;
